import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import ProfilePhotoUpload from "@/components/ui/profile-photo-upload";
import { useAuth } from "@/contexts/AuthContext";

interface InvitedUserProfileFormProps {
  firstName: string;
  setFirstName: (value: string) => void;
  lastName: string;
  setLastName: (value: string) => void;
  companyRole: string;
  setCompanyRole: (value: string) => void;
  personalPhoneNumber: string;
  setPersonalPhoneNumber: (value: string) => void;
  setProfilePhotoUrl: (url: string | null) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  companyName: string;
}

const InvitedUserProfileForm = (props: InvitedUserProfileFormProps) => {
  const { user } = useAuth();
  return (
    <form onSubmit={props.onSubmit} className="space-y-6">
      <div className="space-y-4">
        <div className="text-center">
          <h3 className="text-lg font-medium mb-4">Your Profile Photo</h3>
          <ProfilePhotoUpload onImageUpload={props.setProfilePhotoUrl} userId={user?.id} />
        </div>

        <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="firstName">First Name *</Label>
            <Input
              id="firstName"
              value={props.firstName}
              onChange={(e) => props.setFirstName(e.target.value)}
              required
              placeholder="Your first name"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="lastName">Last Name *</Label>
            <Input
              id="lastName"
              value={props.lastName}
              onChange={(e) => props.setLastName(e.target.value)}
              required
              placeholder="Your last name"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="personalPhoneNumber">Personal Phone Number *</Label>
          <Input
            id="personalPhoneNumber"
            value={props.personalPhoneNumber}
            onChange={(e) => props.setPersonalPhoneNumber(e.target.value)}
            required
            placeholder="Your personal phone number"
            type="tel"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="companyRole">Your Role at {props.companyName} *</Label>
          <Input
            id="companyRole"
            value={props.companyRole}
            onChange={(e) => props.setCompanyRole(e.target.value)}
            placeholder="e.g. Project Manager, Estimator, Admin"
            required
          />
        </div>
      </div>

      <div className="border-t pt-6">
        <div className="text-center text-sm text-muted-foreground">
          <p>You're joining <strong>{props.companyName}</strong></p>
          <p>Complete your personal information to get started</p>
        </div>
      </div>

      <Button type="submit" className="w-full" disabled={props.isLoading}>
        {props.isLoading ? "Completing Profile..." : "Complete Profile & Join Company"}
      </Button>
    </form>
  );
};

export default InvitedUserProfileForm;